"use strict";

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {

			init: function init() {

				$(".js-global-form-button").click(function () {
					$(".js-global-form").toggleClass("global-form--open");
				});
			}
		};
	}, { "./global": 2 }], 2: [function (require, module, exports) {
		"use strict";

		module.exports = {
			$dom: {
				window: $(window),
				body: $('body'),
				siteHeader: $('.site-header')
			},

			vars: {
				windowWidth: window.innerWidth
			},

			functions: {
				escKey: function escKey(callback) {
					$(document).on('keyup', function (e) {
						if (e.keyCode === 27) {
							callback();
						}
					});
				},

				clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
					selector.on('mouseup', function (e) {
						e.preventDefault();
						if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
							callback();
						}
					});
				}
			}
		};
	}, {}], 3: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				menuBtn: $('.js-menu-btn'),
				menuNav: $('.js-main-nav'),
				menuHasSub: $('.menu-item-has-children')
			},

			classes: {
				open: 'open',
				openMenu: 'menu-open'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeNav() {
					$dom.menuBtn.removeClass(classes.open);
					$dom.menuNav.removeClass(classes.open);
					Global.$dom.body.removeClass(classes.openMenu);
				}

				if (Global.vars.windowWidth < 1199) {
					$dom.menuHasSub.each(function (i, el) {
						$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
					});
				}

				// bind events
				$dom.menuBtn.on('click', function (e) {
					e.preventDefault();
					$dom.menuBtn.toggleClass(classes.open);
					$dom.menuNav.toggleClass(classes.open);
					Global.$dom.body.toggleClass(classes.openMenu);
				});

				$dom.menuNav.on('click', '[data-open-sub]', function () {
					if (Global.vars.windowWidth < 768) {
						$(this).siblings('.sub-menu').slideToggle();
					}
				});

				Global.functions.clickOutsideContainer($dom.menuNav, $dom.menuNav.children('ul'), $dom.menuBtn, closeNav);

				Global.functions.escKey(closeNav);
			}
		};
	}, { "./global": 2 }], 4: [function (require, module, exports) {
		"use strict";

		module.exports = {
			init: function init() {

				var allPlayers = $('.container-music__slider').find('.custom-player');

				$('.custom-player').each(function () {
					var playerComponents = {
						player: $(this),
						track: $(this).find('.custom-player-audio')[0],
						$btn: $(this).find('.custom-player-button'),
						$progCont: $(this).find('.custom-player-prog-container'),
						$progBar: $(this).find('.custom-player-prog-bar')
					};

					playerComponents.$btn.on('click', function () {
						togglePlay(playerComponents);
						updatePlayer(playerComponents);
					});

					playerComponents.$progCont.on('click', function (e) {
						playerComponents.clickedPos = (e.originalEvent.clientX || e.clientX) - $(this).offset().left;
						playerComponents.track.currentTime = playerComponents.clickedPos * playerComponents.track.duration / playerComponents.$progCont.width();

						updatePlayer(playerComponents);
					});

					updatePlayer(playerComponents);
				});

				function updatePlayer(comps) {
					var percent = comps.track.currentTime / comps.track.duration;

					comps.$progBar.css({
						transform: 'scale(' + percent + ', 1)'
					});

					if (comps.track.paused) {
						return false;
					}

					setTimeout(function () {
						updatePlayer(comps);
					}, 100);
				}

				function togglePlay(comps) {

					var arrayLength = allPlayers.length;
					for (var i = 0; i < arrayLength; i++) {
						if (allPlayers[i].getAttribute("data-my-slick-attr") != comps.player[0].getAttribute("data-my-slick-attr")) {
							var audio = $(allPlayers[i]).find('.custom-player-audio')[0];
							audio.pause();
							audio.currentTime = 0;
							$(allPlayers[i]).addClass('custom-player-paused');
						}
					}
					if (comps.track.paused) {
						comps.track.play();
						comps.player.removeClass('custom-player-paused');
					} else {
						comps.track.pause();
						comps.player.addClass('custom-player-paused');
					}
				}
			}
		};
	}, {}], 5: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {

			init: function init() {
				// get dom and strings
				var branding = $('.site-header');
				$(window).scroll(function () {
					var scroll = $(window).scrollTop();
					if (scroll >= 50) {
						branding.addClass("site-header-alt");
					} else {
						branding.removeClass("site-header-alt");
					}
				});

				var globalForm = $('.global-form');
				$(window).scroll(function () {
					var scroll = $(window).scrollTop();
					if (scroll >= 50) {
						globalForm.addClass("global-form-alt");
					} else {
						globalForm.removeClass("global-form-alt");
					}
				});
			}
		};
	}, { "./global": 2 }], 6: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {

			init: function init() {

				$(document).ready(function () {
					setTimeout(function () {
						$('#ctn-preloader').addClass('loaded');
						$('#preloader-body').removeClass('no-scroll-y');

						if ($('#ctn-preloader').hasClass('loaded')) {
							$('#preloader').delay(1000).queue(function () {
								$(this).remove();
							});
						}
					}, 1500);
				});
			}
		};
	}, { "./global": 2 }], 7: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				raspored: $('.raspored-vreme'),
				boja1: $('.boja-1'),
				boja2: $('.boja-2'),
				boja3: $('.boja-3'),
				boja4: $('.boja-4'),
				boja5: $('.boja-5'),
				boja6: $('.boja-6'),
				boja7: $('.boja-7'),
				boja8: $('.boja-8'),
				boja9: $('.boja-9'),
				boja10: $('.boja-10'),
				boja11: $('.boja-11')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;

				$dom.boja1.hover(function () {
					$.each($dom.boja1, function (i, elem) {
						$(elem).toggleClass('boja-1-hover');
					});
				});

				$dom.boja2.hover(function () {
					$.each($dom.boja2, function (i, elem) {
						$(elem).toggleClass('boja-2-hover');
					});
				});

				$dom.boja3.hover(function () {
					$.each($dom.boja3, function (i, elem) {
						$(elem).toggleClass('boja-3-hover');
					});
				});

				$dom.boja4.hover(function () {
					$.each($dom.boja4, function (i, elem) {
						$(elem).toggleClass('boja-4-hover');
					});
				});

				$dom.boja5.hover(function () {
					$.each($dom.boja5, function (i, elem) {
						$(elem).toggleClass('boja-5-hover');
					});
				});

				$dom.boja6.hover(function () {
					$.each($dom.boja6, function (i, elem) {
						$(elem).toggleClass('boja-6-hover');
					});
				});

				$dom.boja7.hover(function () {
					$.each($dom.boja7, function (i, elem) {
						$(elem).toggleClass('boja-7-hover');
					});
				});
				$dom.boja8.hover(function () {
					$.each($dom.boja8, function (i, elem) {
						$(elem).toggleClass('boja-8-hover');
					});
				});

				$dom.boja9.hover(function () {
					$.each($dom.boja9, function (i, elem) {
						$(elem).toggleClass('boja-9-hover');
					});
				});

				$dom.boja10.hover(function () {
					$.each($dom.boja10, function (i, elem) {
						$(elem).toggleClass('boja-10-hover');
					});
				});

				$dom.boja11.hover(function () {
					$.each($dom.boja11, function (i, elem) {
						$(elem).toggleClass('boja-11-hover');
					});
				});
			}
		};
	}, {}], 8: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				fancybox: $('.js-fancybox-zoom-in-out')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/

			init: function init() {
				var $dom = this.$dom;

				$(document).ready(function () {

					$('ul.tabs li').click(function () {
						var tab_id = $(this).attr('data-tab');

						$('ul.tabs li').removeClass('current--2');
						$('.tab-content').removeClass('current--2');

						$(this).addClass('current--2');
						$("#" + tab_id).addClass('current--2');
					});
				});
			}
		};
	}, {}], 9: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				slider: $('.js-slider'),
				sliderBlog: $('.js-slider-blog'),
				sliderNews: $('.js-slider-news'),
				sliderSingle: $('.slider-picture'),
				sliderNav: $('.slider-text'),
				textSlider: $('.js-text-slider'),
				sliderImgPKursevi: $('.js-plesni-kursevi-img'),
				sliderNavPKursevi: $('.js-plesni-slider-nav'),
				plesoviSlider: $('.js-plesovi-slider'),
				bannerSlider: $('.js-banner-slider'),
				videoSlider: $('.js-video-slider'),
				musicSlider: $('.js-music-slider')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;

				$dom.sliderImgPKursevi.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					fade: true,
					asNavFor: '.js-plesni-slider-nav'
				});
				$dom.sliderNavPKursevi.slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					asNavFor: '.js-plesni-kursevi-img',
					arrows: false,
					centerMode: true,
					focusOnSelect: true
				});

				// slider
				$dom.slider.slick({
					infinite: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					speed: 1000,
					arrows: false,
					responsive: [{
						breakpoint: 991,
						settings: {
							slidesToShow: 3
						}
					}, {
						breakpoint: 767,
						settings: {
							slidesToShow: 2
						}
					}]
				});

				$dom.textSlider.slick({
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					arrows: false,
					autoplay: true,
					autoplaySpeed: 5000,
					fade: true,
					cssEase: 'linear'
				});

				// slider
				$dom.sliderBlog.slick({
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
					speed: 1000,
					arrows: true,
					prevArrow: $('.js-prev-slide-blog'),
					nextArrow: $('.js-next-slide-blog'),
					responsive: [{
						breakpoint: 992,
						settings: {
							slidesToShow: 2
						}
					}, {
						breakpoint: 576,
						settings: {
							slidesToShow: 1

						}
					}]
				});

				// slider
				$dom.sliderNews.slick({
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
					speed: 1000,
					arrows: false,
					autoplay: true,
					prevArrow: $('.js-prev-slide-news'),
					nextArrow: $('.js-next-slide-news'),
					responsive: [{
						breakpoint: 992,
						settings: {
							slidesToShow: 2
						}
					}, {
						breakpoint: 576,
						settings: {
							slidesToShow: 1
						}
					}]
				});

				$dom.sliderSingle.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					fade: true,
					speed: 1500,
					asNavFor: '.slider-text'
				});

				$(document).ready(function () {
					var time = 8;
					var $bar, $sliderNav, isPause, tick, percentTime;

					$dom.sliderNav.slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						asNavFor: '.slider-picture',
						dots: true,
						arrows: false,
						speed: 1500,
						customPaging: function customPaging(slider, i) {
							return '<button class="tab">' + $(slider.$slides[i]).attr('data-slide-title') + '</button>';
						}
					});

					$bar = $('.slider-progress .progress');

					$('.text__wrap').on({
						mouseenter: function mouseenter() {
							isPause = true;
						},
						mouseleave: function mouseleave() {
							isPause = false;
						}
					});

					function startProgressbar() {
						resetProgressbar();
						percentTime = 0;
						isPause = false;
						tick = setInterval(interval, 10);
					}

					function interval() {
						if (isPause === false) {
							percentTime += 1 / (time + 0.1);
							$bar.css({
								width: percentTime + "%"
							});
							if (percentTime >= 100) {
								$dom.sliderNav.slick('slickNext');
								startProgressbar();
							}
						}
					}

					function resetProgressbar() {
						$bar.css({
							width: 0 + '%'
						});
						clearTimeout(tick);
					}

					startProgressbar();
				});

				// slider
				$dom.plesoviSlider.slick({
					infinite: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					speed: 1000,
					arrows: false,
					autoplay: true,
					autoplaySpeed: 2000,
					responsive: [{
						breakpoint: 992,
						settings: {
							slidesToShow: 3
						}
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: 2
						}
					}, {
						breakpoint: 481,
						settings: {
							slidesToShow: 1
						}
					}]
				});

				$.each($dom.bannerSlider, function (i, e) {
					$(e).slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 4000,
						speed: 3000,
						width: 900,
						prevArrow: $(e).closest('.banner-slider__wrap').find('.js-prev-banner-slider'),
						nextArrow: $(e).closest('.banner-slider__wrap').find('.js-next-banner-slider')
					});
				});

				$.each($dom.videoSlider, function (i, e) {
					$(e).slick({
						slidesToShow: 3,
						slidesToScroll: 1,
						autoplaySpeed: 2000,
						speed: 500,
						prevArrow: $(e).closest('.video-slider').find('.js-prev-video-slider'),
						nextArrow: $(e).closest('.video-slider').find('.js-next-video-slider'),
						responsive: [{
							breakpoint: 768,
							settings: {
								slidesToShow: 2
							}
						}, {
							breakpoint: 480,
							settings: {
								slidesToShow: 1
							}
						}]
					});
				});

				$.each($dom.musicSlider, function (i, e) {
					$(e).on("afterChange", function (event, slick, current_slide_index, next_slide_index) {
						addCustomSlickAttributes();
					});

					function addCustomSlickAttributes() {
						$("[data-my-slick-attr]").removeAttr("data-my-slick-attr");

						$("[aria-hidden='false']").each(function (index, el) {
							$(el).attr("data-my-slick-attr", index);
						});

						$("[aria-hidden='true']").each(function (index, el) {
							$(el).attr("data-my-slick-attr", -1);
						});
					}

					$(e).on("init", function (event, slick) {
						addCustomSlickAttributes();
					});

					$(e).slick({
						vertical: true,
						slidesToShow: 4,
						slidesToScroll: 1,
						verticalSwiping: true,
						speed: 300,
						prevArrow: $(e).closest('.container-music__slider').find('.js-next-music-slider'),
						nextArrow: $(e).closest('.container-music__slider').find('.js-prev-music-slider')
					});
				});
			}

		};
	}, {}], 10: [function (require, module, exports) {
		jQuery(function ($) {
			//Site Menu
			var menu = require('./_site/menu');
			menu.init();

			// Slick Slider
			var sliders = require('./_site/sliders');
			sliders.init();

			// Admin Site Header
			// const adminBarShift = require('./_site/adminSiteHeader');
			// adminBarShift.init();

			var raspored = require('./_site/raspored-casova');
			raspored.init();

			var navScroll = require('./_site/navigationScroll');
			navScroll.init();

			var rasporedTab = require('./_site/raspored-tab');
			rasporedTab.init();

			var globalForm = require('./_site/global-form');
			globalForm.init();

			var preloader = require('./_site/preloader');
			preloader.init();

			var musicPlayer = require('./_site/music-player');
			musicPlayer.init();
		});
	}, { "./_site/global-form": 1, "./_site/menu": 3, "./_site/music-player": 4, "./_site/navigationScroll": 5, "./_site/preloader": 6, "./_site/raspored-casova": 7, "./_site/raspored-tab": 8, "./_site/sliders": 9 }] }, {}, [10]);